import DatePicker from 'react-date-picker';
import styled from 'styled-components'
import ButtonReg from 'atoms/Buttons/Button';
import FormTypeahead from 'atoms/Inputs/FormTypeahead';

export const PageWrapper = styled.div.attrs(({ isMobile }) => ({
  className: 'p-4'
}))``

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  padding: 20px 10px;

  .react-bootstrap-table {
    display: block;
    overflow: auto;
    max-height: ${window.innerHeight - 425}px;
    width: 100%;

    table {
      table-layout: auto;
    }
  }
`

export const EmptyWrapper = styled.div.attrs({
  className: 'mt-3'
})`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  height: calc(100vh - 400px);
  background-color: ${({ theme }) => theme.getRGBA(theme.mocaGrey, 0.1)};

  @media (max-width: 768px) {
    height: calc(100vh - 484px);
  }
`

export const FilterRow = styled.div.attrs({
  className: 'col-12 mt-3 px-0'
})`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: ${({pb}) => pb ? '0 15px ' + pb + 'px 15px' : '0 15px 0px 15px'}  !important;
  gap: 16px;

  @media (max-width: 1024px) {
    gap: 5px;
    flex-wrap: wrap;
    padding-top: 0 !important;
  }

  @media (max-width: 768px) {
    gap: 10px;
  }
`

export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`

export const TableWrapper = styled.div.attrs({
  className: 'mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  overflow-x: auto;

  .react-bootstrap-table {
    display: block;
    overflow-x: auto;
    width: 100%;

    table {
      table-layout: auto;
    }
  }
`

export const PaddedWrapper = styled.div.attrs({
  className: 'p-3'
})``

export const HyphenWrapper = styled.div.attrs({
})`
  display: flex;
  align-items: center;
  height: 34px;
`

export const StyledDatePicker = styled(DatePicker)`
  .react-date-picker__wrapper {
    border-radius: 6px !important;
    font-size: 14px !important;
    height: 34px !important;
    border: 1px solid ${({ theme }) => theme.mocaGrey};
  }
  .react-date-picker__inputGroup {
    padding-left: 12px;
  }
  .react-date-picker__inputGroup__month {
    appearance:none;
    pointer-events: none;
  }
`

export const Button = styled(ButtonReg)`
  margin-right: ${({ mr }) => mr || 0};
  margin-top: ${({ mt }) => mt || 0};
`

export const Typeahead = styled(FormTypeahead)`
  .rbt-input-main {
    border-color: ${({ theme }) => theme.mocaGrey};
    border-radius: 6px;
    font-size: 14px;
    height: 34px;
    padding: 9px 12px;
  }

  .rbt-input-hint input {
    box-sizing: border-box !important;
    height: 34px;
  }
`
